import React, {useCallback, useMemo} from 'react';
import {classes, style} from './doppe-layout-actions-list.st.css';
import {DoppeTemplateInstance} from '../../../../doppe-sdk';
import {DoppeViewerAction} from '../../../doppe-viewer-action/doppe-viewer-action';
import {DoppeTemplateBasedActionView} from '../../../doppe-template-based-action-view/doppe-template-based-action-view';
import {
    DoppeActionViewInnerContentCloseButton
} from '../../../doppe-action-view-inner-content-close-button/doppe-action-view-inner-content-close-button';
import {DoppeViewerActionsList} from '../../../doppe-viewer-actions-list/doppe-viewer-actions-list';
import {doppeActionIsVisibleInPage, DoppeDtoAction} from "../../../../client-server-common/types/doppe-dto-action";
import {iterableAny} from "@wix/devzai-utils-common";

export const DoppeLayoutActionsList = React.memo(function DoppeLayoutActionsList(
    props: DoppeLayoutActionsList.Props
) {
    const {
        className,
        children,
        disableItemsAnimation,

        actions,
        actionButtonTemplate,

        ...htmlAttributes
    } = props;

    const hasActions = useMemo(() => {
        return iterableAny(actions, doppeActionIsVisibleInPage);
    }, [actions]);

    const actionViewRenderFunction = useCallback<DoppeViewerAction.ActionViewRenderFunction>(renderProps => {
        return (
            <DoppeTemplateBasedActionView
                {...renderProps.actionViewContextProps}
                actionViewTemplate={actionButtonTemplate}
                renderInlineContentCloseButton={renderProps => {
                    return (
                        <DoppeActionViewInnerContentCloseButton
                            onCloseButtonClick={renderProps.closingFunction}
                        />
                    )
                }}
            />
        )
    }, [actionButtonTemplate])


    return (hasActions ?
            <DoppeViewerActionsList
                {...htmlAttributes}
                className={style(classes.actionsList, {}, className)}
                renderActionView={actionViewRenderFunction}
                disableItemsAnimation={disableItemsAnimation}
                actions={actions}
                actionButtonTemplate={actionButtonTemplate}
            />
            :
            null
    )
});

export namespace DoppeLayoutActionsList {

    export interface Props extends React.HTMLAttributes<any> {
        actions: DoppeDtoAction[];
        actionButtonTemplate: DoppeTemplateInstance;
        disableItemsAnimation?: boolean;
    }
}